import { createInjectionKey } from "../../_utils/index.mjs";
export const messageApiInjectionKey = createInjectionKey('n-message-api');
export const messageProviderInjectionKey = createInjectionKey('n-message-provider');